import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { Link } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import { FileText, FolderOpen, BookOpen, Inbox, Image as ImageIcon, Wrench } from 'lucide-react';

const CARDS = [
    { label: 'Stranice', icon: FileText, key: 'pages', endpoint: '/admin/pages', href: '/admin/pages' },
    { label: 'Usluge', icon: Wrench, key: 'services', endpoint: '/admin/services', href: '/admin/services' },
    { label: 'Reference', icon: FolderOpen, key: 'projects', endpoint: '/admin/projects', href: '/admin/projects' },
    { label: 'Blog objave', icon: BookOpen, key: 'blog', endpoint: '/admin/blog', href: '/admin/blog' },
    { label: 'Poruke', icon: Inbox, key: 'messages', endpoint: '/admin/messages', href: '/admin/messages' },
    { label: 'Mediji', icon: ImageIcon, key: 'media', endpoint: '/admin/media', href: '/admin/media' },
];

export default function AdminDashboard() {
    const [counts, setCounts] = useState({});

    useEffect(() => {
        Promise.all(CARDS.map((c) => api.get(c.endpoint).then((r) => [c.key, r.data.length]).catch(() => [c.key, 0])))
            .then((arr) => setCounts(Object.fromEntries(arr)));
    }, []);

    return (
        <div>
            <h1 className="text-2xl font-medium">Pregled</h1>
            <p className="text-sm text-white/60 mt-1">Statistika i brze akcije.</p>

            <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {CARDS.map((c) => {
                    const Icon = c.icon;
                    return (
                        <Link key={c.key} to={c.href} className="group rounded-xl border border-[#232A36] bg-[#111318] hover:border-[#B08D57] transition-colors p-5">
                            <div className="flex items-center justify-between">
                                <Icon className="h-5 w-5 text-[#B08D57]" />
                                <span className="text-xs uppercase tracking-[0.18em] text-white/50">{c.label}</span>
                            </div>
                            <p className="mt-4 text-3xl font-medium">{counts[c.key] ?? '—'}</p>
                            <p className="mt-1 text-xs text-white/55 group-hover:text-white">Upravljaj →</p>
                        </Link>
                    );
                })}
            </div>

            <Card className="mt-8 bg-[#111318] border-[#232A36] p-6">
                <h2 className="text-lg font-medium">Brze akcije</h2>
                <ul className="mt-3 grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm">
                    <li><Link to="/admin/pages" className="text-white/80 hover:text-white">• Uredi stranicu</Link></li>
                    <li><Link to="/admin/blog" className="text-white/80 hover:text-white">• Nova blog objava</Link></li>
                    <li><Link to="/admin/projects" className="text-white/80 hover:text-white">• Dodaj referencu</Link></li>
                    <li><Link to="/admin/media" className="text-white/80 hover:text-white">• Uploaduj sliku</Link></li>
                    <li><Link to="/admin/redirects" className="text-white/80 hover:text-white">• Dodaj redirect</Link></li>
                    <li><Link to="/admin/settings" className="text-white/80 hover:text-white">• Postavke sajta</Link></li>
                </ul>
            </Card>
        </div>
    );
}
